import clsx from 'clsx';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import moneyApi from '~/api/moneyApi';
import { getDayMonth, getTime } from '~/utils/datetime';
import { toSringKVnd } from '~/utils/money';
import styles from './MoneyInfo.module.scss';
import { actions, useStore } from '~/store';

function MoneyInfo({
    id,
    datetime,
    placeName,
    type,
    name,
    amount,
    active,
    onDeleteSuccess,
}) {
    const [state, dispatch] = useStore();
    const { tripId } = state;
    const navigate = useNavigate();
    const [showOtherAction, setShowOtherAction] = useState(false);

    const handleOnClickCopy = () => {
        navigate(`/add/${id}`);
    };

    const handleOnClickEdit = () => {
        navigate(`/edit/${id}`);
    };

    const handleOnClickMore = () => {
        setShowOtherAction((pre) => !pre);
    };

    const handleOnClickDelete = () => {
        if (onDeleteSuccess) onDeleteSuccess(id);
        dispatch(
            actions.deleteMoney({
                id,
                tripId,
            }),
        );
        dispatch(actions.setLoading2({ loading2: true }));
        // call api
        moneyApi
            .delete({
                id,
                tripId,
            })
            .then((data) => {
                console.log('data', data);
                if (data && data.code === 0) {
                    toast.success('Đã xóa thành công');
                } else {
                    toast.error('Xóa thất bại. ' + JSON.stringify(data));
                }
                dispatch(actions.setLoading2({ loading2: false }));
            })
            .catch((error) => {
                toast.error(JSON.stringify(error));
                console.log(error);
                dispatch(actions.setLoading2({ loading2: false }));
            });
    };

    return (
        <>
            <div className={clsx(styles.wrapper, active && styles.active)}>
                <div className={styles.left} onClick={handleOnClickMore}>
                    <div className={styles.row}>
                        <div className={styles.date}>
                            {getDayMonth(datetime)}
                        </div>
                        <div className={styles.time}>{getTime(datetime)}</div>
                        <div className={styles.type}>{type}</div>
                    </div>
                    <div className={styles.row}>
                        <div className={styles.place}>{placeName}</div>
                        <div className={styles.amount}>
                            {toSringKVnd(amount)}
                        </div>
                    </div>
                    <div className={styles.row}>
                        <div
                            className={clsx(
                                styles.name,
                                !name && styles.updateName,
                            )}
                        >
                            {name ? name : 'Cập nhật tên đi nào!'}
                        </div>
                        {/* <div className={styles.note}>{note}</div> */}
                    </div>
                </div>
                <div className={styles.right}>
                    <button
                        className={clsx(styles.btn, styles.edit)}
                        onClick={handleOnClickEdit}
                    >
                        <i className="fa-solid fa-pen"></i>
                    </button>
                    {!showOtherAction && (
                        <button
                            className={clsx(styles.btn, styles.more)}
                            onClick={handleOnClickMore}
                        >
                            <i className="fa-solid fa-ellipsis"></i>
                        </button>
                    )}
                    {showOtherAction && (
                        <>
                            <button
                                className={clsx(styles.btn, styles.delete)}
                                onClick={handleOnClickDelete}
                            >
                                <i className="fa-solid fa-trash-can"></i>
                            </button>

                            <button
                                className={clsx(styles.btn, styles.copy)}
                                onClick={handleOnClickCopy}
                            >
                                <i className="fa-regular fa-copy"></i>
                            </button>
                        </>
                    )}
                </div>
            </div>
        </>
    );
}

export default MoneyInfo;
